// src/constants/productConstants.js

// ---------- CATEGORY ----------
export const ADD_PRODUCT_CATEGORY_REQUEST         = "ADD_PRODUCT_CATEGORY_REQUEST";
export const ADD_PRODUCT_CATEGORY_SUCCESS         = "ADD_PRODUCT_CATEGORY_SUCCESS";
export const ADD_PRODUCT_CATEGORY_FAIL            = "ADD_PRODUCT_CATEGORY_FAIL";

export const GET_PRODUCT_CATEGORIES_REQUEST       = "GET_PRODUCT_CATEGORIES_REQUEST";
export const GET_PRODUCT_CATEGORIES_SUCCESS       = "GET_PRODUCT_CATEGORIES_SUCCESS";
export const GET_PRODUCT_CATEGORIES_FAIL          = "GET_PRODUCT_CATEGORIES_FAIL";

export const UPDATE_PRODUCT_CATEGORY_REQUEST      = "UPDATE_PRODUCT_CATEGORY_REQUEST";
export const UPDATE_PRODUCT_CATEGORY_SUCCESS      = "UPDATE_PRODUCT_CATEGORY_SUCCESS";
export const UPDATE_PRODUCT_CATEGORY_FAIL         = "UPDATE_PRODUCT_CATEGORY_FAIL";

export const DELETE_PRODUCT_CATEGORY_REQUEST      = "DELETE_PRODUCT_CATEGORY_REQUEST";
export const DELETE_PRODUCT_CATEGORY_SUCCESS      = "DELETE_PRODUCT_CATEGORY_SUCCESS";
export const DELETE_PRODUCT_CATEGORY_FAIL         = "DELETE_PRODUCT_CATEGORY_FAIL";

// ---------- PRODUCT STOCK ----------
export const ADD_PRODUCT_STOCK_REQUEST            = "ADD_PRODUCT_STOCK_REQUEST";
export const ADD_PRODUCT_STOCK_SUCCESS            = "ADD_PRODUCT_STOCK_SUCCESS";
export const ADD_PRODUCT_STOCK_FAIL               = "ADD_PRODUCT_STOCK_FAIL";

export const GET_ALL_PRODUCT_STOCK_REQUEST        = "GET_ALL_PRODUCT_STOCK_REQUEST";
export const GET_ALL_PRODUCT_STOCK_SUCCESS        = "GET_ALL_PRODUCT_STOCK_SUCCESS";
export const GET_ALL_PRODUCT_STOCK_FAIL           = "GET_ALL_PRODUCT_STOCK_FAIL";

export const UPDATE_PRODUCT_STOCK_REQUEST         = "UPDATE_PRODUCT_STOCK_REQUEST";
export const UPDATE_PRODUCT_STOCK_SUCCESS         = "UPDATE_PRODUCT_STOCK_SUCCESS";
export const UPDATE_PRODUCT_STOCK_FAIL            = "UPDATE_PRODUCT_STOCK_FAIL";

export const DELETE_PRODUCT_STOCK_REQUEST         = "DELETE_PRODUCT_STOCK_REQUEST";
export const DELETE_PRODUCT_STOCK_SUCCESS         = "DELETE_PRODUCT_STOCK_SUCCESS";
export const DELETE_PRODUCT_STOCK_FAIL            = "DELETE_PRODUCT_STOCK_FAIL";

// ---------- COMPONENT STOCK ----------
export const ADD_COMPONENT_STOCK_REQUEST          = "ADD_COMPONENT_STOCK_REQUEST";
export const ADD_COMPONENT_STOCK_SUCCESS          = "ADD_COMPONENT_STOCK_SUCCESS";
export const ADD_COMPONENT_STOCK_FAIL             = "ADD_COMPONENT_STOCK_FAIL";

export const GET_ALL_COMPONENT_STOCK_REQUEST      = "GET_ALL_COMPONENT_STOCK_REQUEST";
export const GET_ALL_COMPONENT_STOCK_SUCCESS      = "GET_ALL_COMPONENT_STOCK_SUCCESS";
export const GET_ALL_COMPONENT_STOCK_FAIL         = "GET_ALL_COMPONENT_STOCK_FAIL";

export const UPDATE_COMPONENT_STOCK_REQUEST       = "UPDATE_COMPONENT_STOCK_REQUEST";
export const UPDATE_COMPONENT_STOCK_SUCCESS       = "UPDATE_COMPONENT_STOCK_SUCCESS";
export const UPDATE_COMPONENT_STOCK_FAIL          = "UPDATE_COMPONENT_STOCK_FAIL";

export const DELETE_COMPONENT_STOCK_REQUEST       = "DELETE_COMPONENT_STOCK_REQUEST";
export const DELETE_COMPONENT_STOCK_SUCCESS       = "DELETE_COMPONENT_STOCK_SUCCESS";
export const DELETE_COMPONENT_STOCK_FAIL          = "DELETE_COMPONENT_STOCK_FAIL";

// ---------- SUPPLIER ----------
export const ADD_SUPPLIER_REQUEST                 = "ADD_SUPPLIER_REQUEST";
export const ADD_SUPPLIER_SUCCESS                 = "ADD_SUPPLIER_SUCCESS";
export const ADD_SUPPLIER_FAIL                    = "ADD_SUPPLIER_FAIL";

export const GET_ALL_SUPPLIERS_REQUEST            = "GET_ALL_SUPPLIERS_REQUEST";
export const GET_ALL_SUPPLIERS_SUCCESS            = "GET_ALL_SUPPLIERS_SUCCESS";
export const GET_ALL_SUPPLIERS_FAIL               = "GET_ALL_SUPPLIERS_FAIL";

export const UPDATE_SUPPLIER_REQUEST              = "UPDATE_SUPPLIER_REQUEST";
export const UPDATE_SUPPLIER_SUCCESS              = "UPDATE_SUPPLIER_SUCCESS";
export const UPDATE_SUPPLIER_FAIL                 = "UPDATE_SUPPLIER_FAIL";

export const DELETE_SUPPLIER_REQUEST              = "DELETE_SUPPLIER_REQUEST";
export const DELETE_SUPPLIER_SUCCESS              = "DELETE_SUPPLIER_SUCCESS";
export const DELETE_SUPPLIER_FAIL                 = "DELETE_SUPPLIER_FAIL";

// ---------- RETURN/REFUND ----------
export const ADD_RETURN_REFUND_REQUEST            = "ADD_RETURN_REFUND_REQUEST";
export const ADD_RETURN_REFUND_SUCCESS            = "ADD_RETURN_REFUND_SUCCESS";
export const ADD_RETURN_REFUND_FAIL               = "ADD_RETURN_REFUND_FAIL";

export const GET_PRODUCT_RETURN_REFUND_HISTORY_REQUEST  = "GET_PRODUCT_RETURN_REFUND_HISTORY_REQUEST";
export const GET_PRODUCT_RETURN_REFUND_HISTORY_SUCCESS  = "GET_PRODUCT_RETURN_REFUND_HISTORY_SUCCESS";
export const GET_PRODUCT_RETURN_REFUND_HISTORY_FAIL     = "GET_PRODUCT_RETURN_REFUND_HISTORY_FAIL";

export const GET_COMPONENT_RETURN_REFUND_HISTORY_REQUEST = "GET_COMPONENT_RETURN_REFUND_HISTORY_REQUEST";
export const GET_COMPONENT_RETURN_REFUND_HISTORY_SUCCESS = "GET_COMPONENT_RETURN_REFUND_HISTORY_SUCCESS";
export const GET_COMPONENT_RETURN_REFUND_HISTORY_FAIL    = "GET_COMPONENT_RETURN_REFUND_HISTORY_FAIL";

export const UPDATE_RETURN_REFUND_REQUEST           = "UPDATE_RETURN_REFUND_REQUEST";
export const UPDATE_RETURN_REFUND_SUCCESS           = "UPDATE_RETURN_REFUND_SUCCESS";
export const UPDATE_RETURN_REFUND_FAIL              = "UPDATE_RETURN_REFUND_FAIL";

export const DELETE_PRODUCT_RETURN_REFUND_REQUEST   = "DELETE_PRODUCT_RETURN_REFUND_REQUEST";
export const DELETE_PRODUCT_RETURN_REFUND_SUCCESS   = "DELETE_PRODUCT_RETURN_REFUND_SUCCESS";
export const DELETE_PRODUCT_RETURN_REFUND_FAIL      = "DELETE_PRODUCT_RETURN_REFUND_FAIL";

export const DELETE_COMPONENT_RETURN_REFUND_REQUEST = "DELETE_COMPONENT_RETURN_REFUND_REQUEST";
export const DELETE_COMPONENT_RETURN_REFUND_SUCCESS = "DELETE_COMPONENT_RETURN_REFUND_SUCCESS";
export const DELETE_COMPONENT_RETURN_REFUND_FAIL    = "DELETE_COMPONENT_RETURN_REFUND_FAIL";

// ---------- ANALYTICS ----------
export const GET_PRODUCT_CATEGORY_ANALYTICS_REQUEST  = "GET_PRODUCT_CATEGORY_ANALYTICS_REQUEST";
export const GET_PRODUCT_CATEGORY_ANALYTICS_SUCCESS  = "GET_PRODUCT_CATEGORY_ANALYTICS_SUCCESS";
export const GET_PRODUCT_CATEGORY_ANALYTICS_FAIL     = "GET_PRODUCT_CATEGORY_ANALYTICS_FAIL";

export const GET_PRODUCT_STOCK_ANALYTICS_REQUEST     = "GET_PRODUCT_STOCK_ANALYTICS_REQUEST";
export const GET_PRODUCT_STOCK_ANALYTICS_SUCCESS     = "GET_PRODUCT_STOCK_ANALYTICS_SUCCESS";
export const GET_PRODUCT_STOCK_ANALYTICS_FAIL        = "GET_PRODUCT_STOCK_ANALYTICS_FAIL";

export const GET_COMPONENT_STOCK_ANALYTICS_REQUEST   = "GET_COMPONENT_STOCK_ANALYTICS_REQUEST";
export const GET_COMPONENT_STOCK_ANALYTICS_SUCCESS   = "GET_COMPONENT_STOCK_ANALYTICS_SUCCESS";
export const GET_COMPONENT_STOCK_ANALYTICS_FAIL      = "GET_COMPONENT_STOCK_ANALYTICS_FAIL";

export const GET_RETURN_REFUND_ANALYTICS_REQUEST     = "GET_RETURN_REFUND_ANALYTICS_REQUEST";
export const GET_RETURN_REFUND_ANALYTICS_SUCCESS     = "GET_RETURN_REFUND_ANALYTICS_SUCCESS";
export const GET_RETURN_REFUND_ANALYTICS_FAIL        = "GET_RETURN_REFUND_ANALYTICS_FAIL";

export const GET_SUPPLIER_PERFORMANCE_ANALYTICS_REQUEST = "GET_SUPPLIER_PERFORMANCE_ANALYTICS_REQUEST";
export const GET_SUPPLIER_PERFORMANCE_ANALYTICS_SUCCESS = "GET_SUPPLIER_PERFORMANCE_ANALYTICS_SUCCESS";
export const GET_SUPPLIER_PERFORMANCE_ANALYTICS_FAIL    = "GET_SUPPLIER_PERFORMANCE_ANALYTICS_FAIL";

// ---------- CLEAR ERRORS/MESSAGES ----------
export const CLEAR_PRODUCT_ERRORS                   = "CLEAR_PRODUCT_ERRORS";
export const CLEAR_PRODUCT_MESSAGES                 = "CLEAR_PRODUCT_MESSAGES";

// ---------- PRODUCT TRANSFER ----------
export const TRANSFER_PRODUCT_STOCK_REQUEST         = "TRANSFER_PRODUCT_STOCK_REQUEST";
export const TRANSFER_PRODUCT_STOCK_SUCCESS         = "TRANSFER_PRODUCT_STOCK_SUCCESS";
export const TRANSFER_PRODUCT_STOCK_FAIL            = "TRANSFER_PRODUCT_STOCK_FAIL";
export const TRANSFER_PRODUCT_STOCK_RESET           = "TRANSFER_PRODUCT_STOCK_RESET";

// ---------- COMPONENT TRANSFER ----------
export const TRANSFER_COMPONENT_STOCK_REQUEST       = "TRANSFER_COMPONENT_STOCK_REQUEST";
export const TRANSFER_COMPONENT_STOCK_SUCCESS       = "TRANSFER_COMPONENT_STOCK_SUCCESS";
export const TRANSFER_COMPONENT_STOCK_FAIL          = "TRANSFER_COMPONENT_STOCK_FAIL";
export const TRANSFER_COMPONENT_STOCK_RESET         = "TRANSFER_COMPONENT_STOCK_RESET";
export const CLEAR_TRANSFER_ERRORS         = "CLEAR_TRANSFER_ERRORS";
